import { Ability } from './interfaces/IAbilityData'
import ISpecCategory from './interfaces/ISpecCategory'
import specialists from './relevantSpecialists'

const specs = {
  [Ability.attention]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 25 },
          specialists: [specialists.Neurologist, specialists.Neuropsychologist]
        },
        {
          range: { start: 25, end: 50 },
          specialists: [specialists.OccupationalTherapy]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 25, end: 50 },
          specialists: [
            specialists.EducationalTherapist,
            specialists.EducationalPsychologist
          ]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.math]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 5 },
          specialists: [specialists.Neuropsychologist]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 25 },
          specialists: [
            specialists.Neuropsychologist,
            specialists.EducationalPsychologist
          ]
        },
        {
          range: { start: 25, end: 50 },
          specialists: [
            specialists.EducationalTherapist,
            specialists.OccupationalTherapy
          ]
        },
        {
          range: { start: 50, end: 75 },
          specialists: [specialists.EducationalTherapist]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.spatial]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 10 },
          specialists: [specialists.Neuropsychologist]
        },
        {
          range: { start: 10, end: 50 },
          specialists: [specialists.OccupationalTherapy]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 10 },
          specialists: [specialists.Neuropsychologist]
        },
        {
          range: { start: 10, end: 50 },
          specialists: [specialists.OccupationalTherapy]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.motor]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 25 },
          specialists: [
            specialists.Physiotherapist,
            specialists.OccupationalTherapy
          ]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 25 },
          specialists: [
            specialists.Physiotherapist,
            specialists.OccupationalTherapy
          ]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.selfEsteem]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 20 },
          specialists: [
            specialists.ClinicalPsychologist,
            specialists.BehavioralTherapist
          ]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 20 },
          specialists: [
            specialists.ClinicalPsychologist,
            specialists.BehavioralTherapist
          ]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.social]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 20 },
          specialists: [
            specialists.Psychiatrist,
            specialists.ClinicalPsychologist
          ]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 20 },
          specialists: [
            specialists.Psychiatrist,
            specialists.ClinicalPsychologist
          ]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.executiveFunctions]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 5 },
          specialists: [specialists.Neuropsychologist]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 25 },
          specialists: [
            specialists.Neuropsychologist,
            specialists.EducationalPsychologist
          ]
        },
        {
          range: { start: 25, end: 50 },
          specialists: [specialists.EducationalTherapist]
        },
        {
          range: { start: 50, end: 75 },
          specialists: [specialists.EducationalTherapist]
        }
      ]
    }
  ] as ISpecCategory[],
  [Ability.memory]: [
    {
      title: 'Before 1st Grade (ages 4-5)',
      ranges: [
        {
          range: { start: 0, end: 10 },
          specialists: [
            specialists.Neuropsychologist,
            specialists.EducationalPsychologist
          ]
        },
        {
          range: { start: 10, end: 50 },
          specialists: [specialists.OccupationalTherapy]
        }
      ]
    },
    {
      title: '1st Grade Onwards (ages 6+)',
      ranges: [
        {
          range: { start: 0, end: 10 },
          specialists: [
            specialists.Neuropsychologist,
            specialists.EducationalPsychologist
          ]
        },
        {
          range: { start: 10, end: 50 },
          specialists: [specialists.OccupationalTherapy]
        }
      ]
    }
  ] as ISpecCategory[]
}

export const getSpecialistsByAbility = (ability: Ability): ISpecCategory[] => {
  if (ability in specs) {
    return specs[ability]
  }
  return []
}



// WEBPACK FOOTER //
// ./src/data/abitilies/specialistByCategories.ts